import styled from "styled-components";

const HistoryStyle = styled.div`
    h2 {
        color: #126BA5;
        font-size: 23px;

        margin-bottom: 17px;
    }

    p {
        color: #666666;
        font-size: 18px;
    }
`

export { HistoryStyle }